(() => {
  const drawer = document.getElementById('LumiqCartDrawer');
  if (!drawer || typeof window.LumiqCartDrawer?.add === 'function') return;
  const section = 'lumiq-cart-drawer';
  const status = drawer.querySelector('[role="status"]');
  const errorBox = drawer.querySelector('[role="alert"]');
  let busy = false;
  let opener;
  const show = (trigger) => {
    if (drawer.open) return;
    opener = trigger || document.activeElement;
    drawer.showModal();
    document.documentElement.classList.add('lumiq-cart-open');
    drawer.querySelector('[data-cart-close]').focus();
  };
  const close = () => drawer.close();
  drawer.addEventListener('close', () => {
    document.documentElement.classList.remove('lumiq-cart-open');
    if (opener?.isConnected) opener.focus();
  });
  const setBusy = (value) => {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    status.hidden = !value;
    drawer.querySelectorAll('[data-cart-quantity], .lumiq-cart__checkout').forEach(button => { button.disabled = value; });
  };
  const report = (error) => {
    errorBox.querySelector('span').textContent = error.message || drawer.dataset.error;
    errorBox.hidden = false;
  };
  const render = (html) => {
    if (typeof html !== 'string') return false;
    const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-lumiq-cart-content]');
    if (!content) return false;
    drawer.querySelector('[data-lumiq-cart-content]').replaceWith(content);
    const count = Number(content.dataset.count);
    document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
      bubble.hidden = count === 0;
      bubble.querySelectorAll('span').forEach(span => { span.textContent = String(count); });
    });
    return true;
  };
  const refresh = async () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sections', section);
    const response = await fetch(url, {headers: {'Accept': 'application/json'}, cache: 'no-store'});
    if (!response.ok || !render((await response.json())[section])) throw Error(drawer.dataset.error);
  };
  const reconcile = async (data) => {
    if (!render(data.sections?.[section])) await refresh();
  };
  const open = async (trigger) => {
    show(trigger);
    if (busy) return;
    setBusy(true);
    errorBox.hidden = true;
    try { await refresh(); } catch (error) { report(error); } finally { setBusy(false); }
  };
  const add = async (payload, trigger) => {
    if (busy) { show(trigger); return; }
    setBusy(true);
    errorBox.hidden = true;
    try {
      payload.set('sections', section);
      payload.set('sections_url', window.location.pathname);
      const response = await fetch(drawer.dataset.addUrl + '.js', {method: 'POST', headers: {'Accept': 'application/json'}, body: payload});
      const data = await response.json();
      if (!response.ok) throw Error(data.description || drawer.dataset.error);
      show(trigger);
      try { await reconcile(data); } catch (error) { report(error); }
    } finally { setBusy(false); }
  };
  const change = async (line, quantity) => {
    if (busy) return;
    setBusy(true);
    errorBox.hidden = true;
    try {
      const response = await fetch(drawer.dataset.changeUrl + '.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({line, quantity, sections: [section], sections_url: window.location.pathname})
      });
      const data = await response.json();
      if (!response.ok) throw Error(data.description || drawer.dataset.error);
      await reconcile(data);
      drawer.querySelector(`[data-cart-line="${line}"] [data-cart-quantity]`)?.focus();
      if (document.activeElement === document.body) drawer.querySelector('[data-cart-close]').focus();
    } catch (error) { report(error); } finally { setBusy(false); }
  };
  drawer.addEventListener('click', event => {
    if (event.target === drawer) {
      const rect = drawer.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    }
    if (event.target.closest('[data-cart-close]')) close();
    if (event.target.closest('[data-cart-retry]')) open();
    const button = event.target.closest('[data-cart-quantity]');
    if (button) change(Number(button.closest('[data-cart-line]').dataset.cartLine), Number(button.dataset.cartQuantity));
  });
  window.LumiqCartDrawer = {add, open};
})();
